import { apiClient } from '@/infrastructure/api'
import {
  AppStoreIntegrationsApi,
  AppStoreIntegrationsApiListAvailableIntegrationsRequest,
  AppStoreIntegrationsApiGetIntegrationDetailsRequest,
  AppStoreIntegrationsApiSaveIntegrationCredentialsRequest,
  AppStoreIntegrationsApiGetIntegrationsStatusRequest
} from '@itsrever/rever-api'

const appStoreIntegrationsApi = new AppStoreIntegrationsApi(
  undefined,
  undefined,
  apiClient
)

async function listAvailableIntegrations(
  args: AppStoreIntegrationsApiListAvailableIntegrationsRequest,
  signal?: AbortSignal
) {
  const response = await appStoreIntegrationsApi.listAvailableIntegrations(
    args,
    {
      signal
    }
  )
  return response.data.integrations
}

async function getIntegrationDetails(
  args: AppStoreIntegrationsApiGetIntegrationDetailsRequest,
  signal?: AbortSignal
) {
  const response = await appStoreIntegrationsApi.getIntegrationDetails(args, {
    signal
  })
  return response.data
}

async function saveIntegrationCredentials(
  args: AppStoreIntegrationsApiSaveIntegrationCredentialsRequest,
  signal?: AbortSignal
) {
  const response = await appStoreIntegrationsApi.saveIntegrationCredentials(
    args,
    {
      signal
    }
  )
  return response.data
}

async function getIntegrationStatus(
  args: AppStoreIntegrationsApiGetIntegrationsStatusRequest,
  signal?: AbortSignal
) {
  const response = await appStoreIntegrationsApi.getIntegrationsStatus(args, {
    signal
  })
  return response.data
}

export default {
  listAvailableIntegrations,
  getIntegrationDetails,
  saveIntegrationCredentials,
  getIntegrationStatus
}
